module.exports = __webpack_public_path__ + "static/media/gmail.3894fda5.png";